export async function invokeCodedFormFlowAsync(formFlowDefinition, input) {
    let formFlowResult;
    if (input) {
        const args = extractArguments(formFlowDefinition, input);
        formFlowResult = await formFlowDefinition.invokeCodedFormFlow(...args);
    }
    else {
        formFlowResult = await formFlowDefinition.invokeCodedFormFlow();
    }
    return extractOutputResult(formFlowDefinition, formFlowResult);
}
function extractArguments(formFlowDefinition, input) {
    const inputNames = formFlowDefinition.invokeCodedFormFlow
        .toString()
        .replace(/((\/\/.*$)|(\/\*[\s\S]*?\*\/)|(\s))/gm, "")
        .match(/[^(]*\(\s*([^)]*)\)/m)?.[1]
        .split(/,/) ?? [];
    const values = [];
    for (const name of inputNames) {
        if (name in input) {
            values.push(input[name]);
        }
        else {
            throw new Error(`[Form Flow Engine] Form flow "${formFlowDefinition.PK}", no input value passed for "${name}".`);
        }
    }
    for (const key in input) {
        if (!inputNames.includes(key)) {
            throw new Error(`[Form Flow Engine] Form flow "${formFlowDefinition.PK}", extra input value "${key}" passed.`);
        }
    }
    return values;
}
function extractOutputResult(formFlowDefinition, formFlowResult) {
    if (!formFlowDefinition.OutParameters?.length) {
        return undefined;
    }
    if (formFlowDefinition.OutParameters.length === 1) {
        const result = {};
        result[formFlowDefinition.OutParameters[0].Name] = formFlowResult;
        return result;
    }
    return formFlowResult;
}
